import React, { useEffect, useState } from 'react';
import api from '../api';
import NewsCard from '../components/NewsCard';
import FeaturedNews from '../components/FeaturedNews';
import FutureNews from '../components/FutureNews';
import SidebarVideos from '../components/SidebarVideos';
import SEO from '../components/SEO';
import StructuredData, { createWebSiteSchema, createOrganizationSchema } from '../components/StructuredData';
import './HomePage.css';

function HomePage() {
  const [trending, setTrending] = useState([]);
  const [latestNews, setLatestNews] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const [trendingRes, latestRes] = await Promise.all([
          api.get('/api/news/trending'),
          // fetch latest from live API (same behavior as before)
          api.get('/api/news?limit=12'),
        ]);

        if (trendingRes.data.success) setTrending(trendingRes.data.data);
        if (latestRes.data.success) setLatestNews(latestRes.data.data);
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return (
      <div className="loading">
        <div className="spinner"></div>
      </div>
    );
  }

  // Create structured data
  const websiteSchema = createWebSiteSchema();
  const organizationSchema = createOrganizationSchema();

  return (
    <div className="home-page">
      {/* SEO Meta Tags */}
      <SEO
        title="RR NEWS TV FASTEST UPDATE - ताज़ा खबरें, ब्रेकिंग न्यूज़, हिंदी समाचार"
        description="RR NEWS TV FASTEST UPDATE पर पढ़ें देश-विदेश की ताज़ा खबरें, ब्रेकिंग न्यूज़, राजनीति, खेल, मनोरंजन, व्यापार और अन्य समाचार हिंदी में"
        keywords="RR News, RR NEWS TV, Fastest Update, आर आर न्यूज़, समाचार, ब्रेकिंग न्यूज़, हिंदी न्यूज़, hindi news"
        url="/"
        type="website"
      />
      
      {/* Structured Data */}
      <StructuredData data={websiteSchema} />
      <StructuredData data={organizationSchema} />
      
      <div className="container">
        <div className="content-layout">
          {/* Main column: place featured at the top so sidebar aligns with first news */}
          <div className="main-content">
              {/* Ujala Latest (DB-featured set by superadmin) */}
              <FeaturedNews title={"RR NEWS लेटेस्ट"} fullWidth={true} />

              {/* Latest News Section (API/live) */}
              <h2 className="section-title">📰 ताज़ा खबरें</h2>
              <div className="news-grid">
                {latestNews.map((news) => (
                  <NewsCard key={news._id} news={news} />
                ))}
              </div>

              {/* Future / Live Featured Section (from API) */}
              <FutureNews title={"भविष्य की खबरें"} />
          </div>

          {/* Sidebar - Multiple Widgets */}
          <aside className="sidebar">
            <SidebarVideos />

            {/* Trending News Widget */}
            <div className="sidebar-widget">
              <h3 className="widget-title">🔥 ट्रेंडिंग न्यूज़</h3>
              <div className="trending-list">
                {trending.slice(0, 5).map((news, index) => (
                  <a
                    key={news._id}
                    href={`/news/${news.slug}`}
                    className="trending-item"
                  >
                    <span className="trending-number">{index + 1}</span>
                    <div className="trending-content">
                      <h4>{news.title}</h4>
                      <span className="trending-views">
                        👁️ {news.views.toLocaleString('hi-IN')}
                      </span>
                    </div>
                  </a>
                ))}
              </div>
            </div>
          </aside>
        </div>
      </div>
    </div>
  );
}

export default HomePage;


